// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Main_mainContainer__3gnaX","mainContainerPadding":"Main_mainContainerPadding__15hrM"};